<template>
  <yiban-tool :flow="flow"> </yiban-tool>
</template>
<script>
import yibanTool from "./yibanTool.vue";
export default {
  components: { yibanTool },
  data() {
    return {
      flow: {
        id: "1637655498083803137",
        name: "巡查管理",
        name1: "巡查待办处理",
      },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/yibanxuncha.vue